import weuijs from 'weui.js'
import http from './http'
import http2 from './http2'
import http3 from './http3'
import httpHcrm from './httpHcrm'
import {getBrower, isBrower} from './utils'
import VHeader from '../components/common/v-header'
import storage from 'good-storage'
import {userCache} from './cache'

export default {
  install(Vue) {
    /* 实例属性 */
    Vue.prototype.$weuijs = weuijs
    Vue.prototype.$http = http
    Vue.prototype.$http2 = http2
    Vue.prototype.$http3 = http3
    Vue.prototype.$httpHcrm = httpHcrm
    Vue.prototype.$cache = storage.session
    Vue.prototype.$device = isBrower('iphone') ? 'iphone' : isBrower('android') ? 'android' : 'other'
    Vue.prototype.$brower = getBrower();

    /* 全局mixin */
    Vue.mixin({
      data() {
        return {
          weuijsDialog: null,
          user: null,
          hosId:'',
          OnlineHosid:'',
          appId:''
        }
      },
      computed: {
        userCommonPatVo() {
          if (this.user && this.user.userCommonPatVo) {
            return this.user.userCommonPatVo
          } else {
            return {}
          }
        },

        userCommonPatRecords() {
          if (this.userCommonPatVo && this.userCommonPatVo.userCommonPatRecords && this.userCommonPatVo.userCommonPatRecords.length > 0) {
            return this.userCommonPatVo.userCommonPatRecords
          } else {
            return []
          }
        },

        loading() {
          return this.$root.$children[0].showLoading
        }

      },
      components: {VHeader},

      created() {
        this.user = userCache.get()
      },

      methods: {
        /**
         * 全局提示未开通功能
         */
        global_noopen() {
          this.weuijsDialog = this.$weuijs.alert('该功能暂未开通')
        },

        //输入框失焦后回到页面首部 IOS12,微信6.7.4有这个问题
        // 解决软键盘关闭导致页面空缺的问题
        global_onBlur() {
          console.log('页面已复位')
          if (isBrower('iphone')) {
            window.scrollTo(0, 0)
          }
        },

        //聊天界面发送和blur冲突
        global_objBlur(id, time=300) {
          console.log('元素失去焦点隐藏iphone的软键盘', id, time)
          if (isBrower('iphone')) {
            if(typeof id !== 'string') console.log('objBlur()参数错误');
            let obj = document.getElementById(id),
              docTouchend = function(event){
                if(event.target != obj){
                  setTimeout(function(){
                    obj.blur();
                  },time);
                }
              }
            if(obj){
              console.log('objBlur()找到元素')
              obj.addEventListener('focus', function(){
                document.addEventListener('touchend', docTouchend, false);
              },false);
            }else{
              throw console.log('objBlur()没有找到元素');
            }
          }
        },
      },
      beforeDestroy() {
        if (this.weuijsDialog) {
          this.weuijsDialog.hide()
          this.weuijsDialog = null
        }
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/lib/install.js